/**
 * Parse a value that may be an ISO string, a Firestore serialized timestamp
 * ({ _seconds, _nanoseconds }), or a Date, into a JS Date.
 */
function toDate(value: unknown): Date {
  if (!value) return new Date();
  if (value instanceof Date) return value;
  if (typeof value === "string") return new Date(value);
  if (typeof value === "number") return new Date(value);
  if (typeof value === "object" && value !== null && "_seconds" in value) {
    return new Date((value as { _seconds: number })._seconds * 1000);
  }
  return new Date();
}

/** "Mar 13, 2026, 2:30 PM" */
export function formatDate(value: unknown): string {
  try {
    return toDate(value).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return String(value);
  }
}

/** "3/13/2026" */
export function formatDateShort(value: unknown): string {
  try {
    return toDate(value).toLocaleDateString("en-US");
  } catch {
    return String(value);
  }
}

/** "Thu, Mar 13, 2026, 2:30 PM" */
export function formatDateTime(value: unknown): string {
  try {
    return toDate(value).toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return String(value);
  }
}
